import { FiRefreshCw, FiCreditCard, FiTruck } from "react-icons/fi";

const ProductBadges = () => {
  const badges = [
    {
      id: 1,
      icon: <FiRefreshCw className="text-red-600" size={14} />,
      title: "No Return",
      popupTitle: "Return Policy",
      description: "Non-returnable due to hygiene/perishable nature.",
      position: "left-0 md:left-1/2 md:-translate-x-1/2",
      arrow: "left-6 md:left-1/2 md:-translate-x-1/2",
      link: "/refund-policy"
    },
    {
      id: 2,
      icon: <FiCreditCard className="text-red-600" size={14} />,
      title: "COD",
      popupTitle: "Cash on Delivery",
      description: "Pay at your doorstep using cash or UPI.",
      position: "left-1/2 -translate-x-1/2",
      arrow: "left-1/2 -translate-x-1/2",
      link: "/terms-and-conditions"
    },
    {
      id: 3,
      icon: <FiTruck className="text-red-600" size={14} />,
      title: "All India",
      popupTitle: "Free Shipping",
      description: "We deliver to 25000+ pin codes across India.",
      position: "right-0 md:right-auto md:left-1/2 md:-translate-x-1/2",
      arrow: "right-6 md:right-auto md:left-1/2 md:-translate-x-1/2",
      link: "/shipping-policy"
    },
  ];

  const handleBadgeClick = (link) => {
    // Use window.location for navigation
    window.location.href = link;
    
    // Or if you're using Next.js:
    // router.push(link);
  };

  return (
    <div className="mb-6">
      <div className="grid grid-cols-3 gap-2 max-w-2xl mx-auto">
        {badges.map((item) => (
          <a 
            key={item.id} 
            href={item.link}
            onClick={(e) => {
              e.preventDefault();
              handleBadgeClick(item.link);
            }}
            className="group relative bg-gray-50 rounded-lg p-3 text-center cursor-pointer transition-all hover:bg-white hover:shadow-md border border-transparent hover:border-gray-100 no-underline block"
          >
            
            {/* Popover Box */}
            <div className={`absolute bottom-full mb-3 w-44 md:w-52 p-3 bg-white border border-gray-100 shadow-2xl rounded-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50 ${item.position}`}>
              <p className="text-[11px] md:text-xs font-bold text-red-600 mb-1 leading-tight">{item.popupTitle}</p>
              <p className="text-[10px] md:text-[11px] leading-snug text-gray-500 text-left">
                {item.description}
              </p>
              <div className={`absolute -bottom-1.5 w-3 h-3 bg-white border-b border-r border-gray-100 rotate-45 ${item.arrow}`}></div>
            </div>

            {/* Main Content */}
            <div className="w-8 h-8 md:w-10 md:h-10 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-2 group-hover:scale-110 transition-transform">
              {item.icon}
            </div>
            <span className="text-[10px] sm:text-xs font-semibold text-gray-900 whitespace-nowrap">{item.title}</span>
          </a>
        ))}
      </div>
    </div>
  );
};

export default ProductBadges;